import { Component, inject, Injector, OnInit } from '@angular/core';
import { Database, get, ref, remove } from "@angular/fire/database";
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/baseComponent';


@Component({
  selector: 'app-exercises',
  templateUrl: './exercises.component.html',
  styleUrls: ['./exercises.component.css']
})
export class ExercisesComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  exercises: any = []
  exerciseids: any = []
  sortArray: any = []
  showinfo = false
  sStartDate: any

  constructor(injector: Injector, private authService: AuthService) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = await this.authService.initializeAuth(() => this.onSuccessfullLogin())
  }

  async signInWithGoogle() {
    this.isAuthenticatedWithFirebase = await this.authService.signInWithGoogle()
    if (this.isAuthenticatedWithFirebase) { await this.onSuccessfullLogin() }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  async getData() {
    const exercisesRef = ref(this.database, 'exercises');
    const snapshot = await get(exercisesRef);
    if (snapshot.exists()) {
      this.exerciseids = []
      this.exercises = BaseComponent.toArray(snapshot.val());
      this.exercises.forEach((exercise: any) => {
        const dynamicPlayers = exercise.dynamicData ? BaseComponent.toArray(exercise.dynamicData.players) : [];
        const staticPlayers = exercise.staticData ? BaseComponent.toArray(exercise.staticData.players) : [];
        exercise.players = [...dynamicPlayers, ...staticPlayers];
        exercise.nPlayers = exercise.players.length;
        this.exerciseids.push(exercise.id) // we need this to verify new uniques exercise id 
        exercise.dStartDate = exercise.startdate ? new Date(exercise.startdate) : null;     
      })
    }
  }

  edit(exercise: any) {
    if (exercise == null){ // add new exercise
      let newExerciseid = this.generateExerciseId()
      this.router.navigate(['exerciseedit'],{ queryParams: { id:newExerciseid } })
    }else{
      this.router.navigate(['exerciseedit'],{ queryParams: { id:exercise.id } } )
    }
  }
  
  generateExerciseId(): string {
    let randomString = "";
    let counter = 0 // to avoid infinite loop
    let bFoundInList = false
    do {
      const capitalLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26)); // A-Z
      const digits = Math.floor(Math.random() * 100).toString().padStart(2, '0'); // 00-99
      randomString = capitalLetter + digits;
      // randomString = "T800" // for testing

      bFoundInList = this.exerciseids.includes(randomString)
      counter++
    } while (bFoundInList && counter++ < 500);

    console.log("Exercises.generateExerciseId returned "+randomString+" with "+counter+" loops")
    return randomString;
  }
  
  async remove(exercise: any) {
    this.loader.show()
    await remove(ref(this.database, `exercises/${exercise.id}`));
    await this.getData()
    this.loader.hide()
  }
  openLink(exercise:any) {
    window.open(`https://virtex.cellpodium.com`, '_blank');
  }
  checkBeforeDate() {
    this.exercises.forEach((exercise: any) => {
      if (exercise.dStartDate && exercise.dStartDate < new Date(this.sStartDate)) {
        exercise.checked = true;
      } else {
        exercise.checked = false;
      }
    });
  }
  removeCheckedExercises(){
    this.exercises.forEach((exercise: any) => {
      if (exercise.checked) {
        this.remove(exercise);
      }
    });
  }
}
